import type {
  GetMessagesQuery,
  GetMessagesQueryVariables,
} from '#src/graphql/generated';
import type { TypedDocumentNode } from '@apollo/client';

import { gql } from '@apollo/client';

import { MESSAGE_FIELDS } from '#src/graphql/fragments/message-fields';

export const GET_MESSAGES: TypedDocumentNode<
  GetMessagesQuery,
  GetMessagesQueryVariables
> = gql`
  ${MESSAGE_FIELDS}
  query GetMessages($input: MessagesQueryInput) {
    messages(input: $input) {
      ...MessageFields
      childMessages {
        ...MessageFields
      }
    }
  }
`;
